import * as React from 'react';

export const scoFlagContent: JSX.Element = (
    <>
        <g clipPath='url(#clip0_1_342)'>
            <mask
                id='mask0_1_342'
                style={{ maskType: 'alpha' }}
                maskUnits='userSpaceOnUse'
                x='0'
                y='0'
                width='28'
                height='20'
            >
                <path
                    d='M0 4C0 1.79086 1.79086 0 4 0H24C26.2091 0 28 1.79086 28 4V16C28 18.2091 26.2091 20 24 20H4C1.79086 20 0 18.2091 0 16V4Z'
                    fill='#D9D9D9'
                />
            </mask>
            <g mask='url(#mask0_1_342)'>
                <path
                    d='M25.3333 0H2.66667C1.19391 0 0 1.19391 0 2.66667V17.3333C0 18.8061 1.19391 20 2.66667 20H25.3333C26.8061 20 28 18.8061 28 17.3333V2.66667C28 1.19391 26.8061 0 25.3333 0Z'
                    fill='#418FDE'
                />
                <path
                    d='M-0.00390625 7.44313e-05L2.14851 0L13.9961 8.27512L26.0098 6.50138e-05L27.9961 7.44313e-05V2.02836L16.8609 9.99148L27.9961 17.9546V20.0001H26.0098L13.9961 12.0456L2.14851 20.0001H-0.00390625L0 17.9546L11.4943 9.99148L0 2.02836L-0.00390625 7.44313e-05Z'
                    fill='#F1F5F9'
                />
            </g>
        </g>
        <defs>
            <clipPath id='clip0_1_342'>
                <rect
                    width='28'
                    height='20'
                    rx='4'
                    fill='white'
                />
            </clipPath>
        </defs>
    </>
);
